import { HashimukhPage } from "@hashimukh/client-utils-js";

export const AppPage = HashimukhPage;